/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { FeedbackIssueType } from '../../shared/constants/room';
import { InputConfig } from '../form/TaskInputs/types';

export const generalErrorMessage = `
  An error occurred during submission. Please refresh the page and try
  again, or contact us if you still have trouble.
`;

export const issuesEncouteredInputConfigs: InputConfig[] = [
  {
    id: 'issuesEncountered',
    type: 'multi_checkbox',
    choices: [
      { text: 'Identity verification process', value: FeedbackIssueType.ID_VERIFICATION },
      { text: 'Document signing process', value: FeedbackIssueType.DOCUMENT_SIGNING },
      { text: 'Video and audio quality', value: FeedbackIssueType.VIDEO_AUDIO_QUALITY },
    ],
    required: false,
    display: 'issuesEncountered',
    text: 'Issues Encountered',
    label: 'Did you have issues with any of the following during your closing session?',
  },
  {
    id: 'notaryRating',
    type: 'nps',
    label: 'How would you rate your experience with your notary for this closing session?',
    required: false,
  },
  { label: 'Do you have any additional feedback for us?', id: 'additionalFeedback', type: 'text', required: false },
];
